<h2 mat-dialog-title>Spell: {{spell.name}}</h2>
<mat-dialog-content class="mat-typography">
  <mat-form-field>
    <mat-label>Search spell list</mat-label>
    <input matInput [(ngModel)]="spellFilter" (ngModelChange)="filterSpells()"
      [matAutocomplete]="spellAuto">
    <mat-autocomplete #spellAuto="matAutocomplete" (optionSelected)="onSpellSelect($event)">
      @for (s of filteredSpells; track s) {
        <mat-option [value]="s.name">
          {{s.name}} (Level {{s.level}})
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="spell.name"/>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Level</mat-label>
    <input matInput [(ngModel)]="spell.level" type="number"/>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Description</mat-label>
    <textarea matInput [(ngModel)]="spell.description"></textarea>
  </mat-form-field>
  <mat-dialog-actions>
    @if (!this.isNew) {
      <button mat-button color="warn" (click)="deleteSpell()">Delete</button>
    }
    <span class="spacer"></span>
    @if (this.isNew) {
      <button mat-button [mat-dialog-close]="">Cancel</button>
    }
    <button color="primary" mat-raised-button (click)="upsertSpell()" [mat-dialog-close]="" cdkFocusInitial>Done</button>
  </mat-dialog-actions>
</mat-dialog-content>
